import { Item } from "../Menu";
import { LocalizationMessages } from "../../localization/messages";
import { MenuItem } from "../Menu";
import PropTypes from "prop-types";
import React from "react";

const OddsMobileMenuItem = ({ children, handleClick, trackingInfo }) => {
  const menuItemProps = {
    automationId: "uc-odds-mobile",
    onClick: handleClick,
    item: new Item({
      iconKey: "gear",
      ID: "gear",
      title: LocalizationMessages.odds
    }),
    hasArrow: true,
    trackingInfo
  };

  return (
    <>
      <MenuItem {...menuItemProps}></MenuItem>
      {children}
    </>
  );
};

OddsMobileMenuItem.propTypes = {
  children: PropTypes.node,
  handleClick: PropTypes.func,
  item: PropTypes.object,
  trackingInfo: PropTypes.object
};

export default OddsMobileMenuItem;
